import React from "react";
import Solicitudes from "../../components/2.4 maestras/procesos";

const HomePage = () => {
  return (
    <>
      <Solicitudes />
    </>
  );
};

export default HomePage;
